// Components
import { Input as InputComponent } from "./Input";
import { Root } from "./Root";
import { Error } from "./Error";
import { InputComponent as InputPrimitive } from "./InputComponent";

// Types
import type {
  InputProps,
  InputRootProps,
  InputErrorProps,
  InputInputProps
} from "./Input.types";

// Create the Input namespace
const Input = Object.assign(InputComponent, {
  Root,
  Error,
  Input: InputPrimitive
});

// Export the Input namespace
export { Input };

// Export types
export type { InputProps, InputRootProps, InputErrorProps, InputInputProps };
